import React, { FC, useMemo } from "react";
import * as S from "./styled";

import { AuthCredentialsRequestDTOCountryEnum } from "@app/api/generated-api";
import { useTranslation } from "next-i18next";
import { UseFormRegister } from "react-hook-form";
import { FormInputsType } from "@app/views/authPage/components/authForm";
import { Select } from "antd";
import { regions } from "@app/views/authPage/constants";

interface IPhoneInput {
  region: AuthCredentialsRequestDTOCountryEnum;
  register: UseFormRegister<FormInputsType>;
  setRegion: (region: AuthCredentialsRequestDTOCountryEnum) => void;
}

const PhoneInput: FC<IPhoneInput> = ({ region, register, setRegion }) => {
  const { t } = useTranslation();

  const options = useMemo(() => {
    return Object.entries(regions).map(([key, info]) => ({
      value: key,
      label: (
        <S.FlagWrapper>
          {info.icon}
          <S.RegionCode>{info.code}</S.RegionCode>
        </S.FlagWrapper>
      ),
      fullLabel: (
        <S.FlagWrapper>
          {info.icon}
          <S.RegionCode>{`${info.code} ${info.name}`}</S.RegionCode>
        </S.FlagWrapper>
      ),
    }));
  }, []);

  return (
    <S.InputWrapper>
      <Select
        value={region}
        onChange={(val) => setRegion(val)}
        style={{ width: 120 }}
        optionLabelProp="label"
        getPopupContainer={(trigger) => trigger.parentElement!}
        dropdownClassName="region-select-dropdown"
      >
        {options.map((opt) => (
          <Select.Option key={opt.value} value={opt.value} label={opt.label}>
            <S.FlagWrapper>
              {opt.fullLabel}
            </S.FlagWrapper>
          </Select.Option>
        ))}
      </Select>
      <S.PhoneInput
        type="phone"
        id="phone"
        mask={regions[region].mask}
        placeholder={t("common:auth.phonePlaceholder", {code: regions[region].code})}
        {...register("phone")}
      />
    </S.InputWrapper>
  );
};

export default PhoneInput;
